export default "__VITE_ASSET__DJ6m7V5C__"